import React, { useState } from "react";
import { IconButton } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import HeightIcon from "@mui/icons-material/Height";

import MomentumPopup from "./MomentumPopup";
import MarketSharePopup from "./MarketSharePopup";
const TrendButton = ({ trending, title, apiData, type }) => {
  const [open, setOpen] = useState(false);

  const getButtonStyles = () => ({
    backgroundColor:
      trending === "up"
        ? "#EDF9F7"
        : trending === "equal"
        ? "#FEFBEE"
        : "#FEEEEF",
    borderRadius: "3px",
    height: "1.2rem",
    width: "3rem",
    "&:hover": { backgroundColor: "#e1f5e3" },
  });

  const renderIcon = () => {
    switch (trending) {
      case "up":
        return <TrendingUpIcon style={{ color: "green", fontSize: "1rem" }} />;
      case "equal":
        return (
          <HeightIcon
            style={{
              transform: "rotate(90deg)",
              color: "#DB6E00",
              fontSize: "1rem",
            }}
          />
        );
      case "down":
      default:
        return <TrendingDownIcon style={{ color: "red", fontSize: "1rem" }} />;
    }
  };

  return (
    <div>
      <IconButton
        onClick={() => setOpen(true)}
        sx={getButtonStyles()}
        aria-label={title}
      >
        {renderIcon()}
      </IconButton>
      {open && type === 'momentum' && <MomentumPopup title={title} open={open} apiData={apiData} setOpen={setOpen} />}
      {open && type === 'marketShare' && <MarketSharePopup title={title} open={open} apiData={apiData} setOpen={setOpen} />}
    </div>
  );
};

export default TrendButton;
